import React, { memo } from 'react'
import { SecureWrapper } from '../layout/SecureWrapper'
import { InsuranceCoverageForm } from './InsuranceCoverageForm'
import { getCurrentCollectDataStep } from 'src/selectors/collectData'
import { InsuranceCollectDataStep } from 'src/interfaces/collectData'
import { useSelector } from 'react-redux'

const InsuranceCoverageComponent = () => {
  const currentStep = useSelector(getCurrentCollectDataStep) as InsuranceCollectDataStep

  return (
    <SecureWrapper>
      <InsuranceCoverageForm
        key={currentStep?.id}
        stepId={currentStep?.id}
        stepInsurancePolicyProductId={currentStep?.metadata?.insurancePolicyProductId}
        stepRequireDocumentUploadWhenOptedIn={
          currentStep?.metadata?.insurancePolicyProduct?.requireDocumentUploadWhenOptedIn
        }
        documentUploadTitleWhenOptedIn={
          currentStep?.metadata?.insurancePolicyProduct?.documentUploadTitleWhenOptedIn
        }
      />
    </SecureWrapper>
  )
}

export const InsuranceCoverage = memo(InsuranceCoverageComponent)
